export const NutresaColors = {
  Primary: "#94BB20",
  Secondary: "#246855"
};
